<template>
  <div>
    <div class="form-group">
      <h3>Radno vrijeme opcije</h3>
      <label for="exampleFormControlSelect1"
        >View available options for work time</label
      >

      <ul class="list-group">
        <li class="list-group-item" v-for="(o, index) in units" :key="o.index">
          {{ o }}
          <span class="btn btn-danger" @click="deleteUnit(index)">Obrisi</span>
        </li>
      </ul>

      <label for="units">Dodaj novi termin za radno vrijeme</label>
      <input
        id="units"
        type="text"
        class="form-control"
        placeholder="Dodaj novu jedinicu"
        v-model="unit"
      />
      <button class="btn btn-success mt-2" @click="addUnit">
        Dodaj
      </button>
    </div>
    <button class="btn btn-primary mt-4" @click="saveChanges">
      Sacuvaj izmjene
    </button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      units: {},
      unit: ""
    };
  },
  created() {
    if (this.getOptions) {
      this.units = this.getOptions.workTime;
    }
  },
  methods: {
    deleteUnit(index) {
      this.units.splice(index, 1);
    },
    addUnit() {
      this.units.push(this.unit);
    },
    saveChanges() {
      this.getOptions.workTime = this.units;
      const updatedWorkTime = {
        prevOpt: this.getOptions
      };
      this.$store.dispatch("updatedAllOptions", updatedWorkTime);
    }
  },
  computed: {
    getOptions() {
      return this.$store.getters.getOptions;
    }
  }
};
</script>
<style></style>
